import useWindowSize from '@vindr/utils/hooks/useWindowSize';
import { Pick } from '@vindr/utils/helpers/common.helper';
import i18n from '@ohif/i18n';
import { Icon } from '@vindr/ui';
import { Dropdown, MenuProps } from 'antd';
import classnames from 'classnames';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const handleChangeLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
  localStorage.setItem('defaultLanguage', lang);
};

const LangOption = ({ lang, label }: { lang: 'vi' | 'en-US'; label: string }) => {
  return (
    <div className="flex" onClick={() => handleChangeLanguage(lang)}>
      <div className="mr-2 w-5">
        <Icon name={lang} className="text-3xl" />
      </div>
      <span>{label}</span>
    </div>
  );
};

const LangItems = [
  {
    key: 'vi',
    title: 'Tiếng việt',
    short_title: '🇻🇳',
    label: <LangOption lang="vi" label="Tiếng việt" />,
  },
  {
    key: 'en-US',
    title: 'English',
    short_title: '🇺🇸',
    label: <LangOption lang="en-US" label="English" />,
  },
];

const getCurrentLang = (currentLang, short: boolean) => {
  const value = currentLang?.[0]?.value ? currentLang[0]?.value : currentLang;
  const languageKeyuageKey = value === 'vi' ? value : 'en-US';

  const result = LangItems.find((lang) => lang.key === languageKeyuageKey);

  return short ? result.short_title : result.title;
};

const LanguageSwitcher = () => {
  const currentLanguage = i18n.language;
  const { t } = useTranslation('Vindoc');
  const { width } = useWindowSize();

  const isShort = useMemo(() => width < 639, [width]);

  const items = useMemo(
    () => LangItems.map((x) => Pick(x, ['key', 'label'])) as MenuProps['items'],
    []
  );

  return (
    <Dropdown
      menu={{ items, selectedKeys: [currentLanguage] }}
      placement="bottomRight"
      className="header-dropdown-title flex items-center hover:cursor-pointer"
      overlayClassName="vindr-dropdown select-language header-dropdown w-30"
    >
      <span className="language-info">
        <span
          className={classnames('current-lang mr-1 text-base', {
            'text-[20px]': isShort,
          })}
        >
          {t(getCurrentLang(currentLanguage, isShort))}
        </span>
        <Icon name="caret-down" className="text-base" />
      </span>
    </Dropdown>
  );
};

export default memo(LanguageSwitcher);
